var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditbutton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.75 12.2911H2.8105L9.796 5.30558L8.7355 4.24508L1.75 11.2306V12.2911ZM13.75 13.7911H0.25V10.6088L10.3262 0.532578C10.4669 0.391975 10.6576 0.312988 10.8565 0.312988C11.0554 0.312988 11.2461 0.391975 11.3867 0.532578L13.5085 2.65433C13.6491 2.79497 13.7281 2.9857 13.7281 3.18458C13.7281 3.38345 13.6491 3.57418 13.5085 3.71483L4.93225 12.2911H13.75V13.7911ZM9.796 3.18458L10.8565 4.24508L11.917 3.18458L10.8565 2.12408L9.796 3.18458V3.18458Z",
    fill: "#003636"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditbutton);
export default __webpack_public_path__ + "static/media/editbutton.363a439fb2b1789e967dc3474aef1304.svg";
export { ForwardRef as ReactComponent };